import React from 'react'
import { getStatusStyle } from '../../../../utils/drivers'

export const ShiftSwapView = ({ data }) => {
  const filteredData = data

  return (
    <React.Fragment>
      <div className='my-table'>
        <table className="table" >
          <thead className="text-black font-bold text-left">
            <tr>
              <th style={{ width: '22%' }}>Employee</th>
              <th style={{ width: '18%' }}>Time Off Date</th>
              <th style={{ width: '13%' }}>Status</th>
              <th style={{ width: '17%' }}>New Work Date</th>
              <th style={{ width: '17%' }}>Created By</th>
              <th style={{ width: '13%' }}>Created On</th>
            </tr>
          </thead>
          <tbody>
            {
              filteredData.length > 0 ? filteredData.map(request => {
                const { text, backgroundColor } = getStatusStyle(request.status);
                return (
                  <tr key={request.id}>
                    <td style={{ verticalAlign: 'middle' }}>
                      {`${request.employee.user.first_name} ${request.employee.user.last_name} (${request.employee.user.username})`}
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.time_off_date}
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <div style={{ backgroundColor: backgroundColor, padding: 5, color: 'white', borderRadius: 3, fontSize: 12 }}>
                          {text}
                        </div>
                      </div>
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.new_work_date}
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.created_by}
                    </td>
                    <td style={{ verticalAlign: 'middle' }}>
                      {request.created_at ? request.created_at.split('T')[0] : ''}
                    </td>
                  </tr>
                )
              }

              ) : (
                <tr>
                  <td colSpan="6" className="text-center align-middle">
                    <div>No Data</div>
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </React.Fragment>

  )
}
